import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { ComponentPropsWithoutRef, JSX } from 'react';

interface SlideshowThumbnailProps extends ComponentPropsWithoutRef<'button'> {
  readonly image: JSX.Element;
  readonly index: number;
  readonly isSelected?: boolean;
}

const SlideshowThumbnail = ({
  image,
  index,
  isSelected = false,
  onClick,
  ...props
}: SlideshowThumbnailProps): JSX.Element => {
  const t = useTranslations();
  return (
    <button
      aria-current={isSelected}
      className={cx(
        'w-1/6 max-w-[5.5rem] grow overflow-hidden rounded-sm bg-white px-1 py-2 transition-all hover:opacity-100 focus:bg-white/100 md:px-1 md:py-2.5',
        {
          'border border-gray-400 opacity-100': isSelected,
          'opacity-50': !isSelected,
        },
      )}
      type="button"
      value={index}
      onClick={onClick}
      {...props}
    >
      <div aria-hidden="true" className="flex justify-center">
        {image}
      </div>
      <span className="sr-only">
        {t('pdp_slideshow_thumbnail_label', {
          index,
        })}
      </span>
    </button>
  );
};

export default SlideshowThumbnail;
